import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwipeDirective } from './swipe-directive';
import { HideHeaderDirective } from './hide-header-directive';
import { PinchZoomDirective } from './pinch-zoom-directive';

@NgModule({
  declarations: [SwipeDirective, HideHeaderDirective, PinchZoomDirective],
  imports: [
    CommonModule
  ],
  exports: [SwipeDirective, HideHeaderDirective, PinchZoomDirective]
})
export class DirectiveModule { }
